export const GET_ELECTRIC_FAIL_RESULT = "GET_ELECTRIC_FAIL_RESULT";
export const GET_ELECTRIC_FAIL_RESULT_SUCCESS = "GET_ELECTRIC_FAIL_RESULT_SUCCESS";
export const GET_ELECTRIC_FAIL_RESULT_ERROR = "GET_ELECTRIC_FAIL_RESULT_ERROR";
export const RESET_ELECTRIC_FAIL_RESULT = "RESET_ELECTRIC_FAIL_RESULT";
export const GET_ELECTRIC_FAIL_CHART = "GET_ELECTRIC_FAIL_CHART";
export const GET_ELECTRIC_FAIL_CHART_SUCCESS = "GET_ELECTRIC_FAIL_CHART_SUCCESS";
export const GET_ELECTRIC_FAIL_CHART_ERROR = "GET_ELECTRIC_FAIL_CHART_ERROR";
